module.exports = __webpack_public_path__ + "fonts/Inter-700-latin70.30a274c.woff2";